import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'
// import Vuexstore from '@/components/vuexstore'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('../views/index.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
